import { Question as IconQuestionMark } from "@phosphor-icons/react";
import Icon from "../../../components/Icon/Icon.tsx";
import IconMap from "../../../components/Icon/IconMap.ts";

const bodyType = row => {
    if(row.type === 'Kill') {
        return <Icon icon={IconMap.Kill} title="Kill" className="text-red text-xl" />
    } else if(row.type === 'Rescue') {
        return <Icon icon={IconMap.Rescue2} title="Rescue" className="text-blue text-xl" />
    }
    return <IconQuestionMark size={16} className="text-400" title="Unknown" />
}

const bodyReward = row => {
    if(row.reward === 'Credits') {
        return <Icon icon={IconMap.Credits} title="Credits" className="text-yellow text-xl" />
    } else if(row.reward === 'DC') {
        return <Icon icon={IconMap.Datacard} title="Datacard" className="text-600 text-xl" />
    } else if(row.reward === 'Beskar') {
        return <Icon icon={IconMap.Beskar} title="Beskar" className="text-800 text-xl" />
    }
    return <IconQuestionMark size={16} className="text-400" title="Unknown" />
}


export {bodyType, bodyReward};
